import React from "react";
import Api from "./Api";
import { debugLog } from "../../utils/debug";

const oneDayInMilli = 86400000;

export function hasExpired(currentDate, statsTtl) {
    return Date.parse(currentDate) > Date.parse(statsTtl.expiresAt);
}

export function oneDayFromNow(currentDate) {
    return new Date(currentDate.getTime() + oneDayInMilli);
}

export function getStats() {
    const statsTtlAsString = sessionStorage.getItem("statsTtl");
    const statsTtl = JSON.parse(statsTtlAsString);

    const currentDate = new Date();
    if (statsTtlAsString) {
        debugLog(Date.parse(currentDate) + " (currentDate)");
        debugLog(Date.parse(statsTtl.expiresAt) + "(statsTtl expiresAt)");
        debugLog("Has expired: " + hasExpired(currentDate, statsTtl));
    }

    // if (statsTtlAsString === null || hasExpired(currentDate, statsTtl)) {
        Api.get(`/stats`)
            .then(res => {
                const stats = res.data;

                const expires = oneDayFromNow(currentDate);

                const statsTtl = {
                    expiresAt: expires,
                    stats: stats
                };

                sessionStorage.setItem("statsTtl", JSON.stringify(statsTtl));
                // this.setState({stats: statsTtl});
            })
    // } else {
    //     this.setState({stats: JSON.parse(sessionStorage.getItem("statsTtl"))});
    // }
}

export function songBookCount() {
    if (!sessionStorage.getItem("statsTtl")) {
        getStats();
    }

    return <> {!sessionStorage.getItem("statsTtl") ? "" : JSON.parse(sessionStorage.getItem("statsTtl")).stats.find(x => x.title === "Song Books").value}</>;
}